'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Dimension = undefined;

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayPluck = require('d2-utilizr/lib/arrayPluck');

var _arrayPluck2 = _interopRequireDefault(_arrayPluck);

var _arrayUnique = require('d2-utilizr/lib/arrayUnique');

var _arrayUnique2 = _interopRequireDefault(_arrayUnique);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUIRED_DIMENSIONS = ['dx', 'pe', 'ou'];

var Dimension = exports.Dimension = undefined;

exports.Dimension = Dimension = function Dimension(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};
    config.items = (0, _arrayFrom2.default)(config.items);

    var Record = refs.api.Record;

    // constructor

    t.dimension = config.dimension;

    t.items = config.items.map(function (record) {
        return new Record(refs, record).val();
    });

    if (config.sorted) {
        t.sorted = config.sorted;
    }

    t.getRefs = function () {
        return refs;
    };
};

Dimension.prototype.log = function (text, noError) {
    if (!noError) {
        console.log(text, this);
    }
};

Dimension.prototype.val = function (noError) {

    // error
    if (!(0, _isString2.default)(this.dimension)) {
        this.log('(Dimension) Dimension is not a string', noError);
        return null;
    }

    // warning
    if (!this.items.length && !(0, _arrayContains2.default)(['co', 'dy', 'longitude', 'latitude'], this.dimension)) {//todo use centralised keys
        //this.log('(Dimension) No items', noError);
        //return null;
    }

    return this;
};

Dimension.prototype.add = function (recordConfig) {
    var t = this,
        refs = t.getRefs();

    var Record = refs.api.Record;


    var record = new Record(refs, recordConfig).val();

    if (record) {
        this.items.push(record);
    }
};

Dimension.prototype.getRecords = function (sortProperty, response, isPure) {
    var records = response ? response.getRecordsByDimensionName(this.dimension) : this.items;

    if (isPure) {
        records = records.slice(0);
    }

    sortProperty = (0, _arrayContains2.default)(['id', 'name'], sortProperty) ? sortProperty : null;

    return sortProperty ? records.sort(function (a, b) {
        return a[sortProperty] > b[sortProperty];
    }) : records;
};

Dimension.prototype.removeItems = function () {
    this.items = [];
};

Dimension.prototype.isRequired = function () {
    return (0, _arrayContains2.default)(REQUIRED_DIMENSIONS, this.dimension);
};

// dep 1

Dimension.prototype.getRecordIds = function (isSorted, response, isPure) {
    var rec = this.getRecords(isSorted ? 'id' : null, response, isPure);

    return (0, _arrayPluck2.default)(rec, 'id');
};

Dimension.prototype.getRecordNames = function (isSorted, response, isPure) {
    return (0, _arrayPluck2.default)(this.getRecords(isSorted ? 'name' : null, response, isPure), 'name');
};

Dimension.prototype.extendRecords = function (response) {
    var t = this;

    var records = t.getRecords();

    records.forEach(function (record) {
        record.setName(null, response);
    });

    return records;
};

Dimension.prototype.toPlugin = function () {
    delete this.klass;

    this.items.forEach(function (record) {
        record.toPlugin();
    });
};

Dimension.prototype.toPost = function () {
    delete this.klass;

    this.items.forEach(function (record) {
        record.toPost();
    });
};

// dep 2

Dimension.prototype.url = function (isSorted, response, isFilter) {
    var url = (isFilter ? 'filter' : 'dimension') + '=' + this.dimension,
        records = (0, _arrayUnique2.default)(this.getRecordIds(isSorted, response, true));

    url += records.length ? ':' + records.join(';') : '';

    return url;
};
//# sourceMappingURL=Dimension.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Dimension.js
 ** module id = 55
 ** module chunks = 0 1
 **/